import { useEffect } from 'react';
import HomeCard from '../../components/HomeCard';
import PageContainer from '../../components/PageContainer';
import { useTheme } from '../../hooks/useTheme';
import servicesImg from '../../assets/services.svg';
import legislationImg from '../../assets/legislation.svg';
import entitiesImg from '../../assets/entities.svg';
import phoneImg from '../../assets/phone.svg';
import mailImg from '../../assets/mail.svg';
import logo from '../../assets/logo.png';
import waveBottomImg from '../../assets/wave2.png';

import { useStyles } from './styles';
import BottomBar from '../../components/BottomBar';
import { Typography } from '@material-ui/core';


function Home() {
  const { changeTheme } = useTheme();

  useEffect(() => {
    changeTheme();
  }, [])

  const classes = useStyles() 
  return (
    <>
      <div className={classes.topBar}>
        <img src={logo} alt="logo"/>
        <Typography variant="h1">SPinfo60+</Typography>
      </div>
      <PageContainer>
        <div className={classes.wrapper}>
          <HomeCard 
            title="Serviços"
            description="Procure aqui por serviços"
            src={servicesImg}
            pathname='/redes'
          />
          <HomeCard 
            title="Legislação e Direitos"
            description="Estatuto do Idoso e mais"
            src={legislationImg}
            pathname='/legislacao'
          />
          <HomeCard 
            title="Entidades e Órgãos"
            description="Governamentais e não governamentais"
            src={entitiesImg}
            pathname='/entidades'
          />
          <HomeCard 
            title="Telefones Úteis"
            description="Encontre aqui números de telefones úteis"
            src={phoneImg}
            pathname='/telefones'
          />
          <HomeCard 
            title="Colabore com o SPinfo60+"
            description="Envie atualizações ou inclusão de serviços que não encontrou aqui"
            src={mailImg}
            mailto="mailto:spinfo60main@gmail.com"
          />
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Home;